<script lang="ts">
	import type { Announcement } from '$lib/server/db/schema';
	import type { User } from '$lib/types/user';
	import AnnouncementModal from './AnnouncementModal.svelte';

	let { user } = $props<{
		user: User | null;
	}>();

	let announcements = $state<Announcement[]>([]);
	let currentAnnouncementIndex = $state(0);
	let showModal = $state(false);

	// Only load announcements for admin users
	$effect(() => {
		if (user?.isAdmin) {
			loadAnnouncements();
		}
	});

	async function loadAnnouncements() {
		try {
			const response = await fetch('/api/announcements');

			if (!response.ok) {
				// If not authorized or error, just silently fail
				return;
			}

			const result = await response.json();

			if (result.success && result.data.announcements.length > 0) {
				announcements = result.data.announcements;
				currentAnnouncementIndex = 0;
				showModal = true;
			}
		} catch (error) {
			// Silently fail - announcements are not critical
			console.debug('Failed to load announcements:', error);
		}
	}

	async function handleDismiss() {
		const currentAnnouncement = announcements[currentAnnouncementIndex];

		if (currentAnnouncement) {
			try {
				// Mark current announcement as dismissed
				await fetch(`/api/announcements/${currentAnnouncement.id}/dismiss`, {
					method: 'POST',
				});
			} catch (error) {
				console.error('Failed to dismiss announcement:', error);
			}
		}

		// Move to next announcement or close modal
		if (currentAnnouncementIndex < announcements.length - 1) {
			currentAnnouncementIndex++;
		} else {
			showModal = false;
			announcements = [];
			currentAnnouncementIndex = 0;
		}
	}

	// Get current announcement to display
	let currentAnnouncement = $derived(
		announcements.length > 0 ? announcements[currentAnnouncementIndex] : null
	);
</script>

{#if currentAnnouncement && showModal}
	<AnnouncementModal
		announcement={currentAnnouncement}
		open={showModal}
		onDismiss={handleDismiss}
	/>
{/if}
